import s from '../../styles/components/general/Footer.module.css';

const ICONS = {
  spotify: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
      <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.5 17.3c-.2.35-.65.45-1 .25-2.75-1.7-6.2-2.05-10.3-1.1-.4.1-.75-.15-.85-.5s.15-.75.5-.85c4.4-1 8.2-.6 11.25 1.25.4.2.5.65.4.95zm1.5-3.3c-.25.4-.8.55-1.2.3-3.15-1.95-7.95-2.5-11.65-1.35-.5.15-.95-.1-1.1-.6-.15-.5.1-.95.6-1.1 4.25-1.3 9.55-.65 13.15 1.55.4.25.55.8.2 1.2zm.15-3.35C15.05 8.5 8.9 8.3 5.3 9.35c-.55.15-1.1-.15-1.25-.7-.15-.55.15-1.1.7-1.25C8.9 6.15 15.8 6.4 20.1 8.95c.5.3.65.95.35 1.45-.3.45-.95.6-1.45.3z" />
    </svg>
  ),
  apple: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
      <path d="M17.05 12.04c-.03-2.9 2.37-4.3 2.48-4.37-1.35-1.98-3.46-2.25-4.21-2.28-1.79-.18-3.5 1.06-4.41 1.06-.91 0-2.31-1.03-3.8-1-1.95.03-3.76 1.14-4.76 2.89-2.03 3.53-.52 8.75 1.46 11.62.97 1.4 2.13 2.98 3.65 2.92 1.47-.06 2.02-.95 3.8-.95 1.77 0 2.27.95 3.82.92 1.58-.03 2.58-1.44 3.54-2.85 1.12-1.63 1.58-3.22 1.6-3.3-.03-.01-3.07-1.18-3.1-4.66h-.07zM14.35 3.63c.8-.98 1.35-2.32 1.2-3.66-1.16.05-2.56.77-3.39 1.75-.75.86-1.4 2.24-1.22 3.55 1.28.1 2.6-.65 3.41-1.64z" />
    </svg>
  ),
  instagram: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
      <path d="M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41-.56-.22-.96-.48-1.38-.9-.42-.42-.68-.82-.9-1.38-.16-.42-.36-1.06-.41-2.23-.06-1.27-.07-1.65-.07-4.85s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41 1.27-.06 1.65-.07 4.85-.07M12 0C8.74 0 8.33.01 7.05.07c-1.28.06-2.15.26-2.91.56-.79.31-1.46.72-2.13 1.38C1.35 2.67.94 3.34.63 4.13c-.3.76-.5 1.63-.56 2.91C.01 8.33 0 8.74 0 12s.01 3.67.07 4.95c.06 1.28.26 2.15.56 2.91.31.79.72 1.46 1.38 2.13.67.67 1.34 1.08 2.13 1.38.76.3 1.63.5 2.91.56C8.33 23.99 8.74 24 12 24s3.67-.01 4.95-.07c1.28-.06 2.15-.26 2.91-.56.79-.31 1.46-.72 2.13-1.38.67-.67 1.08-1.34 1.38-2.13.3-.76.5-1.63.56-2.91.06-1.28.07-1.69.07-4.95s-.01-3.67-.07-4.95c-.06-1.28-.26-2.15-.56-2.91-.31-.79-.72-1.46-1.38-2.13C21.33 1.35 20.66.94 19.87.63c-.76-.3-1.63-.5-2.91-.56C15.67.01 15.26 0 12 0zm0 5.84A6.16 6.16 0 1 0 18.16 12 6.16 6.16 0 0 0 12 5.84zm0 10.16A4 4 0 1 1 16 12a4 4 0 0 1-4 4zm6.41-10.41a1.44 1.44 0 1 1-1.44-1.44 1.44 1.44 0 0 1 1.44 1.44z" />
    </svg>
  ),
  tiktok: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
      <path d="M16.6 5.82c-.9-.83-1.47-2-1.6-3.3h-3.13v13.53c0 1.6-1.3 2.9-2.9 2.9a2.9 2.9 0 0 1 0-5.8c.32 0 .63.05.92.14V9.9a6.17 6.17 0 0 0-.92-.07 6.13 6.13 0 1 0 6.13 6.13V9.4a9.24 9.24 0 0 0 5.4 1.73V7.99a5.7 5.7 0 0 1-3.9-2.17z" />
    </svg>
  ),
  youtube: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
      <path d="M23.5 6.19a3.02 3.02 0 0 0-2.12-2.14C19.53 3.5 12 3.5 12 3.5s-7.53 0-9.38.55A3.02 3.02 0 0 0 .5 6.19 31.6 31.6 0 0 0 0 12a31.6 31.6 0 0 0 .5 5.81 3.02 3.02 0 0 0 2.12 2.14C4.47 20.5 12 20.5 12 20.5s7.53 0 9.38-.55a3.02 3.02 0 0 0 2.12-2.14A31.6 31.6 0 0 0 24 12a31.6 31.6 0 0 0-.5-5.81zM9.6 15.5v-7l6.3 3.5z" />
    </svg>
  ),
};

export default function Footer({ data }) {
  const { logo, links, legal, legalLinks } = data;

  return (
    <footer className={s.container}>
      <div className={s.inner}>
        <div className={s.brand}>
          <img src={logo} alt={legal?.name} className={s.logo} />

          <div className={s.links}>
            {links.map((item) => (
              <a
                key={item.label}
                href={item.url}
                className={s.link}
                aria-label={item.label}
                target="_blank"
                rel="noopener noreferrer"
              >
                {ICONS[item.icon]}
              </a>
            ))}
          </div>
        </div>

        <div className={s.legal}>
          <span>© {new Date().getFullYear()} {legal?.name}</span>
          {legalLinks?.map((l) => (
            <a key={l.label} href={l.url} className={s.legalLink}>
              {l.label}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}